import jwtAuthAxios from "./auth/jwtAuth";

const subscriptionServices = {};

subscriptionServices.getOverview = async () => {
  const { data } = await jwtAuthAxios.get("/subscriptions");
  return data;
};

subscriptionServices.getClientsOverview = async () => {
  const { data } = await jwtAuthAxios.get("/subscriptions", {
    params: { view: "clients" },
  });
  return data;
};

subscriptionServices.getChangeRequests = async () => {
  const { data } = await jwtAuthAxios.get("/subscriptions/change_requests");
  return data;
};

subscriptionServices.resolveChangeRequest = async ({ id, decision, resolutionNote }) => {
  const { data } = await jwtAuthAxios.patch(`/subscriptions/change_requests/${id}`, {
    decision,
    resolution_note: resolutionNote,
  });
  return data;
};

subscriptionServices.changePlan = async ({ planSlug, billingCycle }) => {
  const { data } = await jwtAuthAxios.post("/subscriptions", {
    plan_slug: planSlug,
    billing_cycle: billingCycle,
  });
  return data;
};

subscriptionServices.updateMembership = async ({ membershipId, expiresAt, planSlug }) => {
  const { data } = await jwtAuthAxios.patch(`/subscriptions/memberships/${membershipId}`, {
    expires_at: expiresAt,
    plan_slug: planSlug,
  });
  return data;
};

export default subscriptionServices;
